// noinspection GraphQLUnresolvedReference

import { gql } from "graphql-request";

export const ASSUMPTION_QUERY = gql`
    mutation ExecuteGetScenarioAssumption(
        $inScenarioID: UUID!,
        $inDefaultValue: Int
    ) {
        executeGetScenarioAssumption(
            inScenarioID: $inScenarioID,
            inDefaultValue: $inDefaultValue
        ) {
            ScenarioID
            PlanningCostPercentage
            ConstructionCostPercentage
            CommissioningCostPercentage
            Planning
            Construction
            Commissioning
        }
    }
`;
export const ASSUMPTION_MUTATE = gql`
    mutation ExecuteCreateScenarioAssumption(
        $inScenarioID: UUID!,
        $inPlanningCostPercentage: Decimal!,
        $inConstructionCostPercentage: Decimal!,
        $inCommissioningCostPercentage: Decimal!,
        $inPlanning: Decimal!,
        $inConstruction: Decimal!,
        $inCommissioning: Decimal!
    ) {
        executeCreateScenarioAssumption(
            inScenarioID: $inScenarioID
            inPlanningCostPercentage: $inPlanningCostPercentage
            inConstructionCostPercentage: $inConstructionCostPercentage
            inCommissioningCostPercentage: $inCommissioningCostPercentage
            inPlanning: $inPlanning
            inConstruction: $inConstruction
            inCommissioning: $inCommissioning
        ) {
            result
        }
    }
`;
export const RunModel = gql`
    mutation ExecuteRunScenario(
        $inScenarioID: UUID!
    ) {
        executeRunScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;
